import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { useState } from "react";
import OrderSubTable2 from "./OrderSubtable2";
import { getSerialFromBarcode } from "../../../../shared/utility";
import DeveloperBarcode from "../../../controls/DeveloperBarcode";
import CopyableIdentifier from "../../../controls/CopyableIdentifier";

export default function OrderSubtable1(props) {
  const {
    data,
    loadingRows,
    rowDetails,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    selectedItems,
    setSelectedItems,
    closed,
  } = props;

  const [expandedRows, setExpandedRows] = useState(null);

  const onRowExpand = (event) => {
    const rowData = event.data;
    if (!subRowDetails[rowData.unique_id]) {
      fetchSubRowDetails(rowData);
    }
  };

  const allowExpansion = (rowData) => {
    return rowData.shipped_pallet_id;
  };

  function rowExpansionTemplate(data) {
    return (
      <OrderSubTable2
        data={data}
        loadingRows={subLoadingRows}
        rowDetails={subRowDetails}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />
    );
  }

  const bodyProductName = (item) => {
    return (
      <div className="flex gap-2">
        {item.is_legacy === 1 ? <p className="text-lg my-auto">L</p> : null}
        <div>
          {item.product_name} <br />{" "}
          <span className="font-bold">PLU: {item.plu}</span>
        </div>
      </div>
    );
  };

  const rowStyleClass = (data) => {
    if (data.credit_return_id > 0) {
      return { "bg-cyan-100": true };
    } else if (data.is_returned === 0) {
      return { "bg-gray-100": true };
    } else if (data.is_returned === 1) {
      return { "bg-yellow-100": true };
    }
    return {};
  };

  const weightInKg = (rowData) => {
    return <p>{rowData.total_weight_in_kg}kg</p>;
  };

  const weightInLbs = (rowData) => {
    return <p>{rowData.total_weight_in_lbs}lbs</p>;
  };

  const pieceCount = (rowData) => {
    return <p>{rowData.total_pieces} pieces</p>;
  };

  const cartonCountBody = (rowData) => {
    return <p>{rowData.total_cartons} cartons</p>;
  };

  if (loadingRows[data.unique_id]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const detail = rowDetails[data.unique_id];
  if (!detail) return null;

  const barcodeBody = (rowData) => {
    const returned =
      rowData.credit_return_id > 0
        ? "CR"
        : rowData.is_returned === 1
        ? " RETURNED"
        : null;

    return (
      <div>
        <CopyableIdentifier
          value={rowData.barcode}
          displayValue={`${getSerialFromBarcode(rowData.barcode)}${
            returned ? ` ${returned.trim()}` : ""
          }`}
          description="full barcode"
        />
        <DeveloperBarcode value={rowData.barcode} compact />
      </div>
    );
  };

  const lotNumberBody = (rowData) => (
    <CopyableIdentifier
      value={rowData.lot_number}
      description="lot number"
    />
  );

  return (
    <div>
      <DataTable
        value={rowDetails[data.unique_id]}
        expandedRows={expandedRows}
        onRowToggle={(e) => {
          setExpandedRows(e.data);
        }}
        onRowExpand={onRowExpand}
        rowExpansionTemplate={rowExpansionTemplate}
        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm custom-datatable-items-table shipping-sub-items-table"
        cellClassName="py-2 border-1-bottom-gray px-2 text-sm"
        rowClassName={rowStyleClass}
        selectionMode="checkbox"
      >
        <Column
          header="Product"
          body={bodyProductName}
          style={{ width: "20%" }}
        />
        <Column
          header="Lot Number"
          body={lotNumberBody}
          style={{ width: "15%" }}
        />
        <Column header="Serial" body={barcodeBody} style={{ width: "15%" }} />
        <Column
          header="Carton count"
          body={cartonCountBody}
          style={{ width: "12%", textAlign: "right" }}
        />
        <Column
          header="Weight in kg"
          body={weightInKg}
          style={{ width: "15%", textAlign: "right" }}
        />
        <Column
          header="Weight in lbs"
          body={weightInLbs}
          style={{ width: "15%", textAlign: "right" }}
        />
        <Column
          header="Piece count"
          body={pieceCount}
          style={{ width: "15%", textAlign: "right" }}
        />
        <Column expander={allowExpansion} style={{ width: "6%" }} />
      </DataTable>
    </div>
  );
}
